
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/graphical-abstract-maker-tool",
      function () {
        return require("private-next-pages/graphical-abstract-maker-tool/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/graphical-abstract-maker-tool"])
      });
    }
  